// extracted by mini-css-extract-plugin
module.exports = {"card":"page_card__rfjxV","logo":"page_logo__7Tb5Y"};